import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  Button,
  CustomInput,
  Description,
  Title,
} from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import { useForgotPasswordMutation, useSendOtpMutation } from "../../Data/services/userAuthApi";
import { ACCOUNT_ENUM } from "./Route";
import Toast, { SuccessToast } from "../../Hooks/useToast";

export default function ForgotPassword({ setPage, setEmail }) {
  const { handleSubmit, control, register } = useForm();
  const navigate = useNavigate();
  // const isLoading = true;
  // console.log(isLoading, "isLoading");
  const handleBackButtonClick = () => {
    setPage(ACCOUNT_ENUM.LOGIN);
  };

  const [forgotPassword, { isError, isLoading, isSuccess }] =
  useSendOtpMutation();

  const handleDataSubmit = async (userData) => {
    // console.log(userData);
    setEmail(userData.email)
    // setPage(ACCOUNT_ENUM.OTP);
    // setPage(ACCOUNT_ENUM.LOGIN);
    try {
      // Use unwrap() to get the response data directly
      const response = await forgotPassword(userData);

      console.log(response);

      if (!response.error && response.data.code === 200) {
        // navigate(ACCOUNT_ENUM.OTP);
        setPage(ACCOUNT_ENUM.OTP);
        SuccessToast(response.data.message);
      }

      if (response.error) {
        Toast(response.error.data.message, "error");
      }

      // dispatch(updateLogin(true))
    } catch (error) {
      console.log(error);
      Toast(error?.data?.message, "error");
    }
  };

  return (
    <AccountLayout
      hasBackButton={true}
      handleBackButton={handleBackButtonClick}
    >
      <Title text="Forgot Password" classes="mb-2 black-text" />
      <Description
        text="In order to reset your password you need to enter your registered email address."
        classes="text-center fs-7 black-text"
      />
      <Form onSubmit={handleSubmit(handleDataSubmit)}>
        <Controller
          control={control}
          name="email"
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                placeholder="Email"
                type="email"
                onChange={onChange}
                value={value}
              />
            </InputGroup>
          )}
        />
        <Button
          text="Continue"
          classes="mt-3 mb-2"
          disabled={isLoading}
          type="submit"
        />
      </Form>
    </AccountLayout>
  );
}
